module.exports = __webpack_public_path__ + "fonts/WorkSans-Light.526a1547.ttf";